<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <p>A verification email has been sent to: <b>{{ email }}</b></p>
        <p>Upon receiving the email, click on the link in the email to complete the signup process.</p>
        <p>After completing the signup process, return to this page and click the continue button to return the login page and sign in.</p>
        <p class="text-aerostar-orange">{{message}}</p>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="continue()">Continue</button>
            <button style="margin-right: 1vw;" mat-flat-button (click)="resendVerification()">Resend Verification Email</button>
        </section>
    </section>
</section>